import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "378a6ff6-2963-4213-b573-51b627c8801c",
  publicId: "22",
  name: "dB scale",
  difficulty: 1,
  contentTypes: { audio: true, interactive: false, video: false },
  body: [principle01, principle02, principle03, task01, task02],
};

export default lesson;
